import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { colors, typography } from '../../styles';


const styles = css`
  .Banner_Wrapper {
    margin-bottom:30px;
  }
  .Banner_Result {
    display:flex;
    flex-flow:row wrap;
    justify-content: center;
    padding:40px 0;
    border-bottom:1px solid  ${colors.color1};
    @media (min-width: 992px) {
      padding:40px;
    }
  }

  .Banner_Result:nth-child(2n+1) .Banner_Media {
    padding:30px;
    background-position: calc(50% - 40px) 50%;
    background-repeat:no-repeat;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    width:100%;
    margin-bottom:20px;
    text-align: center;
    @media (min-width: 992px) {
      width:360px;
      margin-bottom:0;
    }
  }
  .Banner_Media {
    padding:30px;
    background-position: calc(50% - -40px) 50%;
    background-repeat:no-repeat;
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    width:100%;
    margin-bottom:20px;
    text-align: center;
    @media (min-width: 992px) {
      width:360px;
      margin-bottom:0;
    }
  }
  .Banner_Media-image {
    background-size:cover;
    background-position: center;
    border-radius:50%;
    border:5px solid whitesmoke;
    width:300px;
    height:300px;
    margin:0 auto;
    @media (min-width: 992px) {
      width:300px;
      height:300px;
    }
  }
  .Banner_Media_Label {
    display:none;
    font:700 16px/1 ${typography.SansSerif};
    @media (min-width: 992px) {
      display:block;
      position:absolute;
      bottom:20px;
      left:20px;
      color:  white;
    }
  }
  .Banner_Content {
    display:flex;
    flex-flow:column wrap;
    justify-content: center;
    width:100%;
    padding:0 20px;
    position: relative;
    text-align: center;
    @media (min-width: 992px) {
      width: calc(100% - 360px);
      margin:0;
      text-align: left;
    }
  }
  .Banner_preTitle {
    @media (min-width: 992px) {
    }
  }
  .Banner_Title {
    color:  ${colors.color5};
    font:700 24px/1 ${typography.SansSerif};
    text-transform: uppercase;
    margin-bottom: 24px;
  }
  .Banner_postTitle {
    font:700 18px/1.4 ${typography.SansSerif};
    color:  ${colors.color1};
    display:block;
    margin-top: 10px;
    width:100%;
  }
  .Banner_Body {
    font:400 16px/34px ${typography.SansSerif};
    color:  ${colors.color5};
  }
`;

function TeamList({ page }) {
  return (
    <div className={styles}>
      <div className="Banner_Wrapper container">
        {
          get(page, 'employee_profiles').map(item => (
            <div key={item.name} className="Banner_Result">
              {
                get(item, 'headshot.contentUrl') &&
                <div className="Banner_Media">
                  <div className="Banner_Media-image" style={{ backgroundImage: `url(${buildThumbnailUrl(item.headshot.contentUrl, { width: 400, height: 400, preserve: true })})` }} />
                </div>
              }
              <div className="Banner_Content">
                <h3>
                  <span className="Banner_Title">{item.name}</span>
                  <span className="Banner_postTitle">{item.job_title}</span>
                </h3>
                <div className="Banner_Body">
                  {item.bio}
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

TeamList.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'our_team',
})(TeamList);



// WEBPACK FOOTER //
// ./src/pages/MeetTheTeam/TeamList.js